import { Statistic } from "./statistic.js";
import { Region } from "./region.js";
import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { createHtppServiceInstance } from "../util/httpManager.js";
import {CommandManagerAPI, StringKeyDictionary} from "../../commonInterfaces.js";
import React from "react";

export default class QuickInfo extends React.Component<QuickInfoProps, any> {
    private _icuh = Helper;
    private _data = null;
    private _template = null;
    private _isLoading = false;
    private _lastUrl = null;
    private lastPromise;

    constructor(props) {
        super(props)
        this._loadData(this.props, true);
        this._setEvents();
    }

    private _loadData = (properties: QuickInfoProps, checkUrlChanged: boolean) => {
        if (this._icuh.hasValue(properties.dynamicApi) && this._icuh.hasValue(properties.dynamicApi.url)) {
            let entity = properties.entity;
            let url = properties.dynamicApi.url;

            const params: any = {};
            for (let key of Object.keys(properties.dynamicApi.parameters)) {
                const value = this.internalParametersEval(properties.dynamicApi.parameters[key], entity, url);
                params[key] = value;
            }
            url += '?' + $.param(params);

            if (!checkUrlChanged || url != this._lastUrl) {
                this._lastUrl = url;
                this._isLoading = true;

                const currentPromise = createHtppServiceInstance()
                    .noBusyIndicator()
                    .get(url);

                this.lastPromise = currentPromise;
                currentPromise.then(result => {
                    if (this.lastPromise == currentPromise) {
                        this._data = result == null || result.length == 0 ? null : result[0];
                        this._template = this._generateTemplate(properties);
                        this._isLoading = false;
                        this.setState({});
                    }
                }
                );
            }
            else {
                this._template = this._generateTemplate(properties);
            }
        }
        else if (this._icuh.hasValue(properties.template)) {
            this._template = this._generateTemplate(properties);
        }
    }

    private internalParametersEval = (codeToeval: string, entity, url: string): any => {
        return eval(codeToeval);
    }

    private _generateTemplate = (properties: QuickInfoProps) => {
        let templateData = {
            entity: properties.entity,
            data: this._data
        };

        try {
            return kendo.template(properties.template)(templateData);
        }
        catch (e) {
            console.error("ERROR template: " + e);
            return "ERROR template";
        }
    }

    private _handleEval = (action: string) => {
        const entity = this.props.entity;
        const allEntities = this.props.allEntities;
        const getValuesForProperty = (propertyName: string) => {
            const newArray = allEntities.map((i) => { return i[propertyName] });
            return newArray;
        };
        return this.inernalActionEval(action, entity, allEntities, getValuesForProperty);
    }

    private inernalActionEval = (codeTooEval: string, entity, allEntities, getValuesForProperty): any => {
        return eval(codeTooEval);
    }

    private
    private _isStatisticVisible = (stat: QuickInfoStatistic): boolean => {
        try {
            return this._handleEval(stat.visible ?? "true")
        } catch (e) {
            console.error(e);
            return true;
        }
    }

    private _setEvents = () => {
        const sheet = General.Sheet.Manager.getTopMostVisibleSheet();
        if (sheet !== null) {
            sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
                this._loadData(this.props, false);
            });
        }
    }

    componentDidUpdate(prevProps: QuickInfoProps) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
            this._loadData(this.props, true);
        }
    }

    render() {
        if (this._isLoading || (this.props.renderAlways !== true && this.props.entity.IsNew)) {
            return null;
        }
        else {
            const statistics = [];
            if (this._icuh.hasValue(this.props.statistics) && this.props.statistics.length > 0) {
                let key = 1;
                for (let stat of this.props.statistics) {
                    if (this._isStatisticVisible(stat)) {
                        statistics.push(
                            <Region title={stat.title} width={"100%"} key={key} isInitiallyCollapsed={stat.isCollapsed} removeChildrenFromDomWhenCollapsed={true}>
                                <Statistic handleEval={this._handleEval} 
                                           field={{ statisticId: stat.statisticId, parameters: stat.parameters, type: "statistic", model: "statistic" + key }} 
                                           value={null} commandManager={this.props.commandManager} />
                            </Region>
                        );
                        key++;
                    }
                }
            }
            <i className='fal fa-calendar-alt' aria-hidden='true'></i>

            return (
                <div className="flex-container" >
                    <div style={{ borderBottom: "1px solid #ececec" }} dangerouslySetInnerHTML={{ __html: this._template }}></div>

                    <div className="flex-container__item vertical-scroll" >
                        {statistics}
                    </div>
                </div>
            );
        }
    }
}

interface QuickInfoProps {
    entity: any;
    allEntities?: any;
    template?: string;
    dynamicApi?: {
        url: string,
        parameters: StringKeyDictionary<string>
    },
    statistics?: Array<QuickInfoStatistic>;
    renderAlways?: boolean;
    commandManager?: CommandManagerAPI;
}


export interface QuickInfoStatistic {
    statisticId: string;
    parameters: StringKeyDictionary<string>;
    title: string;
    isCollapsed?: boolean;
    visible: string
}


